import {
  Component,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';

import { DialogHistoryFilterComponent } from '../dialog-history-filter/dialog-history-filter.component';

import { GateService } from '../../../../data/services/arrival/gate.service';
import { CustomSnackbarService } from '../../../components/custom-snackbar/custom-snackbar-service';

import { PageDto } from '../../../../data/models/dto/arrival/page.dto';
import { GatesMonitorDto } from '../../../../data//models/dto/arrival/gates-monitor.dto';
import { HistoryFilterCategory } from '../dialog-history-filter/model/history-filter-category';
import { GateArrivalsFilterDto } from '../../../../data//models/dto/arrival/gate-arrivals-filter.dto';
import { GroupByDate } from '../../../../data//models/dto/arrival/group-history-by-date';
import {
  groupGatesMonitorByDate,
  populateDtGroup,
} from '../../../../data/factory/history-arrivals.factory';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
})
export class HistoryComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();

  pageIndex: number = 0;
  isFiltered: boolean = false;
  isSearched: boolean = false;

  @Input()
  gateId: string | undefined;
  mobile: boolean = false;

  @HostListener('window:resize', ['$event'])
  isMobile() {
    if (window.screen.width < 768) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
  }

  monitorHistory: GatesMonitorDto[] = [];
  monitorGroupedHistory: GroupByDate[] = [];

  private CONFIG_FILTER_CATEGORY: HistoryFilterCategory[] = [
    {
      name: 'Visualizar',
      options: [
        {
          name: 'Todas as solicitações',
          value: { all: true, status: undefined, hasAuthorization: undefined },
          selected: true,
        },
        {
          name: 'Solicitações canceladas',
          value: {
            status: ['CANCELED'],
            all: undefined,
            hasAuthorization: undefined,
          },
          selected: false,
        },
        {
          name: 'Solicitações com autorização',
          value: { hasAuthorization: true, status: undefined, all: undefined },
          selected: false,
        },
      ],
    },
    {
      name: 'Ordem de exibição',
      options: [
        {
          name: 'Mais recentes primeiro',
          value: { sortByDate: -1 },
          selected: true,
        },
        {
          name: 'Mais antigos primeiro',
          value: { sortByDate: 1 },
          selected: false,
        },
      ],
    },
  ];

  searchQuery: GateArrivalsFilterDto = {
    page: 1,
    limit: 10,
    sortByDate: -1,
    length: 0,
  };

  constructor(
    private gateService: GateService,
    public dialog: MatDialog,
    private snackbar: CustomSnackbarService,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.getArrivalsHistory(this.searchQuery);
    this.isMobile();
  }

  getArrivalsHistory(params: GateArrivalsFilterDto) {
    this.subscription = this.gateService
      .getArrivalsByIdAndFilter(this.gateId!, params)
      .subscribe(
        (response: PageDto<GatesMonitorDto>) => {
          this.populateHistoryArray(response.data);
          this.searchQuery.length = response.total;
          this.searchQuery.page = response.currentPage;
        },
        (error) => {
          if (error.status == 404) this.monitorHistory = [];
          this.monitorGroupedHistory = [];
          this.searchQuery.length = 0;
          console.log('error to get arrivals');
          console.log(error);
        }
      );
  }

  populateHistoryArray(responseHistories: GatesMonitorDto[]) {
    this.monitorHistory = populateDtGroup(responseHistories, this.datePipe);
    this.monitorGroupedHistory = groupGatesMonitorByDate(this.monitorHistory);
  }

  handleSearch(item: string) {
    item && item.length > 0
      ? (this.isSearched = true)
      : (this.isSearched = false);
    this.searchQuery.page = 1;
    this.pageIndex = 0;
    this.searchQuery.name = item;
    this.getArrivalsHistory(this.searchQuery);
    this.isControlsEnabled(this.isSearched, this.monitorHistory);
  }

  handlePageEvent(pageEvt: PageEvent) {
    this.searchQuery.page = pageEvt.pageIndex + 1;
    this.pageIndex = 1;
    this.searchQuery.length = pageEvt.length;
    this.isFiltered = true;
    this.getArrivalsHistory(this.searchQuery);
    this.isControlsEnabled(this.isFiltered, this.monitorHistory);
  }

  filterHistory() {
    const dialogRef = this.dialog.open(DialogHistoryFilterComponent, {
      panelClass: ['dialog-history-filter'],
      data: this.CONFIG_FILTER_CATEGORY,
    });

    dialogRef.afterClosed().subscribe((result: HistoryFilterCategory[]) => {
      if (result) {
        this.CONFIG_FILTER_CATEGORY = result;
        const resp = result.map(
          (cat) => cat.options.filter((opt) => opt.selected)[0]
        );

        resp.forEach(
          (r) => (this.searchQuery = { ...this.searchQuery, ...r.value })
        );
        this.searchQuery.page = 1;
        this.pageIndex = 0;
        this.getArrivalsHistory(this.searchQuery);
        this.isFiltered = true;
        this.snackbar.showNotification('Os filtros foram aplicados', 2000);
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  isControlsEnabled(control: boolean, history: GatesMonitorDto[]): boolean {
    if (control && history.length > 0) {
      return false;
    } else if (!control && history.length == 0) {
      return true;
    } else {
      return false;
    }
  }
}
